'use client';

import React from 'react';
import {useI18n} from '@udemy-v2/i18n';

import {HeroPill} from './hero-pill.react-component';
import {LogoSectionMobile} from './logo-section-mobile';
import {HeroCta} from './hero-cta';
import {PageForType} from '../../types/page';
import {SubscriptionPlan} from '@/generated/graphql';
import assetLoader from '@/utils/asset-loader';
import {ComponentLoader} from '../component-loader/component-loader';

import styles from './hero-section.module.scss';

// Text element component for consistent text rendering
const TextElement = ({text}: {text: string}) => {
    return <>{text}</>;
};

interface HeroSectionProps {
    pageFor?: PageForType | null;
    subscriptionPlans?: SubscriptionPlan[] | null;
    countryCode?: string | null;
}

function HeroSectionMobile({pageFor, subscriptionPlans, countryCode}: HeroSectionProps) {
    const {gettext} = useI18n();
    const firstGroup = gettext('Indeed is teaming up with Udemy to help you');
    const secondGroup = gettext('employers need so you can');
    const thirdGroup = gettext('of your dreams');

    return (
        <div className={styles.container_mobile}>
            <div className={styles.body_mobile}>
                <section className={styles.headline_mobile}>
                    <TextElement text={firstGroup} />
                    <HeroPill
                        className="hero_pill_with_images"
                        text={gettext('get the skills')}
                        imageSrc={[
                            {
                                source: assetLoader({
                                    src: '/indeed/images/icons/pie-chart.png',
                                }),
                                className: 'pie-chart',
                            },
                            {
                                source: assetLoader({
                                    src: '/indeed/images/icons/icon-ai.png',
                                }),
                                className: 'icon-ai',
                            },
                            {
                                source: assetLoader({
                                    src: '/indeed/images/icons/keyboard.png',
                                }),
                                className: 'keyboard',
                            },
                        ]}
                        background="radial-gradient(152.91% 164.43% at -12.09% -20.69%, #2A2B3F 0%, #6D28D2 20.95%, #A435F0 67.37%, #A435F0 80%)"
                        hoverEffect="apart"
                        textColor="white"
                    />

                    <TextElement text={secondGroup} />

                    <HeroPill
                        text={gettext('land the job')}
                        imageSrc={[
                            {
                                source: assetLoader({
                                    src: '/indeed/images/icons/building.png',
                                }),
                                className: 'building',
                            },
                        ]}
                        background="#FFECDB"
                        hoverEffect="float"
                        textColor="black"
                    />
                    <TextElement text={thirdGroup} />
                </section>
                <section className={styles.cta_section_mobile}>
                    <ComponentLoader
                        pageFor={pageFor}
                        subscriptionPlans={subscriptionPlans}
                        countryCode={countryCode}
                        Component={HeroCta}
                    />
                    <LogoSectionMobile />
                </section>
            </div>
        </div>
    );
}

export {HeroSectionMobile};
